import { FlippingAxisEnum } from '../../enums/ProductEnums';
import { AttributeDTO } from './AttributeDTO';
import { LocalizedTextDTO } from './LocalizedTextDTO';
import { ProductRelationShipDTO } from './ProductRelationshipDTO';
import { TextureDataDTO } from './TextureDataDTO';

export class AttributeValueDTO {
  id: number;
  thumbnailUrl: string;
  infoText: LocalizedTextDTO[];
  attributes: AttributeDTO[];
  externalId: string;
  builderData?: string;
  attributeValueIds: number[];
  displayParameters?: string;

  constructor(
    id: number,
    thumbnailUrl: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[],
    externalId: string,
    attributeValueIds: number[],
    builderData?: string,
    displayParameters?: string,
  ) {
    this.id = id;
    this.thumbnailUrl = thumbnailUrl;
    this.infoText = infoText;
    this.attributes = attributes;
    this.externalId = externalId;
    this.builderData = builderData;
    this.attributeValueIds = attributeValueIds;
    this.displayParameters = displayParameters;
  }
}

export class VariationValueDTO extends AttributeValueDTO {
  productBlueprintId: number;
  constructor(
    id: number,
    thumbnailUrl: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[],
    externalId: string,
    attributeValueIds: number[],
    productBlueprintId: number,
    builderData?: string,
    displayParameters?: string,
  ) {
    super(id, thumbnailUrl, infoText, attributes, externalId, attributeValueIds, builderData, displayParameters);
    this.productBlueprintId = productBlueprintId;
  }
}
export class MaterialValueDTO extends AttributeValueDTO {
  textureData: TextureDataDTO;
  materialInfo?: string;

  constructor(
    id: number,
    thumbnailUrl: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[],
    externalId: string,
    attributeValueIds: number[],
    textureData: TextureDataDTO,
    materialInfo?: string,
    builderData?: string,
    displayParameters?: string,
  ) {
    super(id, thumbnailUrl, infoText, attributes, externalId, attributeValueIds, builderData, displayParameters);
    this.textureData = textureData;
    this.materialInfo = materialInfo;
  }
}
export class ModelValueDTO extends AttributeValueDTO {
  productRelationships: ProductRelationShipDTO[];
  constructor(
    id: number,
    thumbnailUrl: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[],
    externalId: string,
    attributeValueIds: number[],
    productRelationships: ProductRelationShipDTO[],
    builderData?: string,
    displayParameters?: string,
  ) {
    super(id, thumbnailUrl, infoText, attributes, externalId, attributeValueIds, builderData, displayParameters);
    this.productRelationships = productRelationships;
  }
}
export class FlipValueDTO extends AttributeValueDTO {
  flippingAxis: FlippingAxisEnum;
  flippingValue: number;
  constructor(
    id: number,
    thumbnailUrl: string,
    infoText: LocalizedTextDTO[],
    attributes: AttributeDTO[],
    externalId: string,
    attributeValueIds: number[],
    flippingAxis: FlippingAxisEnum,
    flippingValue: number,
    builderData?: string,
    displayParameters?: string,
  ) {
    super(id, thumbnailUrl, infoText, attributes, externalId, attributeValueIds, builderData, displayParameters);
    this.flippingAxis = flippingAxis;
    this.flippingValue = flippingValue;
  }
}
